<template>
  <div>
    <button v-if="!useRouter" @click="btnClicked" :class="{ primary: isPrimary }">
      <slot />
    </button>
    <router-link v-if="useRouter" :to="{ name: routeDestination }" tag="button">{{
      buttonText
    }}</router-link>
  </div>
</template>

<script>
export default {
  name: 'CactusButton',
  props: {
    isPrimary: {
      type: Boolean,
      default: false
    },
    useRouter: {
      type: Boolean,
      default: false
    },
    routeDestination: String,
    buttonText: String
  },
  methods: {
    btnClicked() {
      this.$emit('btnClicked');
    }
  }
};
</script>

<style lang="scss" scoped>
:disabled {
  opacity: 0.35;
  pointer-events: none;
}

button {
  @include textCharts;
  display: inline-block;
  border-radius: 8px;
  background-color: $cloudy-blue;
  border: none;
  color: $petrol;
  width: $maxWidth * 0.9;
  height: 48px;
  line-height: 48px;
  cursor: pointer;
  margin-bottom: 10px;

  &.primary {
    background-color: $greeny-blue;
    color: white;
  }

  > * {
    display: block;
    color: inherit;
    width: 100%;
    height: 100%;
  }
}
</style>
